import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import images from "ressources/images";

const OneHrFormationItem = ({ id, title, duration, image, percent }) => {
  const { t } = useTranslation();

  const progressBarStyle = {
    width: percent + "%",
  };

  const url = image || images.default_category_bg;

  return (
    <Link
      to={{
        pathname: `/onehr/course/${id}`,
      }}
    >
      <div className="formation_item">
        <div
          className="formation_container"
          style={{
            backgroundImage: "url(" + url + ")",
          }}
        >
          <div className="formation_item-middle">
            {/* <div className="formation_brand">{brand}</div> */}
            <div className="formation_title">{title}</div>
          </div>
          <div className="formation_item-bottom">
            <div className="formation_type">{t("course")}</div>
            <div className="time_progress">
              <div className="formation_progress">
                <div className="progress" style={progressBarStyle}></div>
              </div>
              <div className="formation_time">
                <div className="time">{duration}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default OneHrFormationItem;
